import { APP_PDC_URL } from "../../../config";

import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";
import { overflowNotificationConstants } from "../overflowNotification";

export const templatesConstants = {
  GET_TEMPLATES_ASK_ERROR: "GET_TEMPLATES_ASK_ERROR",
  GET_TEMPLATES_ASK_START: "GET_TEMPLATES_ASK_START",
  GET_TEMPLATES_ASK_SUCCESS: "GET_TEMPLATES_ASK_SUCCESS",

  GET_TEMPLATE_DETAIL_ASK_ERROR: "GET_TEMPLATE_DETAIL_ASK_ERROR",
  GET_TEMPLATE_DETAIL_ASK_START: "GET_TEMPLATE_DETAIL_ASK_START",
  GET_TEMPLATE_DETAIL_ASK_SUCCESS: "GET_TEMPLATE_DETAIL_ASK_SUCCESS",

  CREATE_TEMPLATE_ASK_ERROR: "CREATE_TEMPLATE_ASK_ERROR",
  CREATE_TEMPLATE_ASK_START: "CREATE_TEMPLATE_ASK_START",
  CREATE_TEMPLATE_ASK_SUCCESS: "CREATE_TEMPLATE_ASK_SUCCESS",

  DELETE_TEMPLATE_ASK_ERROR: "DELETE_TEMPLATE_ASK_ERROR",
  DELETE_TEMPLATE_ASK_START: "DELETE_TEMPLATE_ASK_START",
  DELETE_TEMPLATE_ASK_SUCCESS: "DELETE_TEMPLATE_ASK_SUCCESS"
};

export function getTemplatesAsk() {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }

    return new Promise(function(resolve, reject) {
      let request = {
        method: "GET",
        url:
          APP_PDC_URL +
          "/api/v1/ask/templates?itemId=" +
          (companyUuidSelected ? companyUuidSelected : accountantUuidSelected),
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: templatesConstants.GET_TEMPLATES_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(response => {
          dispatch({
            type: templatesConstants.GET_TEMPLATES_ASK_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch(err => {
          dispatch({
            type: templatesConstants.GET_TEMPLATES_ASK_ERROR,
            error: err.toString()
          });
          reject(err);
        });
    });
  };
}

export function getTemplateDetailAsk(templateId) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;
    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "get",
        url:
          APP_PDC_URL +
          "/api/v1/templates/" +
          templateId +
          "?managerId=" +
          accountantUuidSelected +
          (companyUuidSelected ? "&itemId=" + companyUuidSelected : ""),
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: templatesConstants.GET_TEMPLATE_DETAIL_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: templatesConstants.GET_TEMPLATE_DETAIL_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: templatesConstants.GET_TEMPLATE_DETAIL_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: templatesConstants.GET_TEMPLATE_DETAIL_ASK_ERROR,
            error: response.toString()
          });
          reject();
        });
    });
  };
}

export function createTemplateAsk(bodyRequest) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantUuidSelected = getState().main.accountantUuidSelected;
    const companyUuidSelected = getState().main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }
    return new Promise((resolve, reject) => {
      let request = {
        method: "POST",
        url: APP_PDC_URL + "/api/v1/templates",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        },
        data: bodyRequest
      };

      dispatch({
        type: templatesConstants.CREATE_TEMPLATE_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: templatesConstants.CREATE_TEMPLATE_ASK_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: templatesConstants.CREATE_TEMPLATE_ASK_ERROR,
              error: result
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: templatesConstants.CREATE_TEMPLATE_ASK_ERROR,
            error: response.toString()
          });
          reject();
        });
    });
  };
}

export function deleteTemplateAsk(templateId) {

  return (dispatch, getState) => {
    const auth = getState().auth;
    const main = getState().main;
    const accountantUuidSelected = main.accountantUuidSelected;
    const companyUuidSelected = main.companyUuidSelected;

    const additionalHeaders = {
      "X-Manager-ID": accountantUuidSelected
    };

    if (companyUuidSelected) {
      additionalHeaders["X-Item-ID"] = companyUuidSelected;
    }

    return new Promise((resolve, reject) => {
      let request = {
        method: "DELETE",
        url: APP_PDC_URL + "/api/v1/templates/" + templateId,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: templatesConstants.DELETE_TEMPLATE_ASK_START
      });

      callWithRetry(
        auth, request, dispatch
      )
        .then(async result => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: templatesConstants.DELETE_TEMPLATE_ASK_SUCCESS,
              payload: result.data
            });
            dispatch({
              type: overflowNotificationConstants.SHOW_OVERFLOW,
              payload: {
                type: "success",
                title: "OK",
                message: "Template eliminato con successo"
              }
            });
          } else {
            dispatch({
              type: templatesConstants.DELETE_TEMPLATE_ASK_ERROR,
              error: result
            });
            dispatch({
              type: overflowNotificationConstants.SHOW_OVERFLOW,
              payload: {
                type: "error",
                title: "Errore",
                message: "Impossibile eliminare il template selezionato"
              }
            });
          }
          resolve(result.data);
        })
        .catch(response => {
          dispatch({
            type: templatesConstants.DELETE_TEMPLATE_ASK_ERROR,
            error: response.toString()
          });
          dispatch({
            type: overflowNotificationConstants.SHOW_OVERFLOW,
            payload: {
              type: "error",
              title: "Errore",
              message: "Impossibile eliminare il template selezionato"
            }
          });
          reject();
        });
    });
  };
}
